import { LoadingOutlined } from '@ant-design/icons';

import { Alert, Spin } from 'antd';

import { UI_JOB_STATUS } from './BulkUploaderUtils';

const EODeliverInfoMessage = ({ status, failureMessage, hasSubmitFile }) => {
  const getMessage = () => {
    switch (status) {
      case UI_JOB_STATUS.uploading:
        return { type: 'info', message: 'Please upload a CSV file with FBA IDs to begin validation.' };
      case UI_JOB_STATUS.uploaded:
        return { type: 'info', message: 'File uploaded. Click "Run Validation" to validate the file.' };
      case UI_JOB_STATUS.validating:
        return { type: 'info', message: 'Validating file. This may take a few minutes...' };
      case UI_JOB_STATUS.validated:
        if (hasSubmitFile) {
          return { type: 'success', message: 'File ready for submission. Click "Submit" to mark orders as delivered.' };
        }
        return {
          type: 'success',
          message:
            'Validation successful. Download the enriched CSV, fill in Delivery Date, then upload and click Submit.'
        };
      case UI_JOB_STATUS.validationFailed:
        return {
          type: 'error',
          message: 'Validation failed. Please download the file to view errors, fix them, and re-upload.'
        };
      case UI_JOB_STATUS.submitting:
        return { type: 'info', message: 'Submitting delivery request. Please wait...' };
      case UI_JOB_STATUS.submitted:
        return { type: 'success', message: 'Delivery completed successfully!' };
      case UI_JOB_STATUS.submitFailed:
        return {
          type: 'error',
          message: failureMessage || 'Delivery failed. Please download the result file for details.'
        };
      case UI_JOB_STATUS.errorOnExecution:
        return { type: 'error', message: 'An error occurred during processing. Please try again.' };
      default:
        return null;
    }
  };

  const alertProps = getMessage();

  if (!alertProps) return null;

  const isLoading = status === UI_JOB_STATUS.validating || status === UI_JOB_STATUS.submitting;

  return (
    <Alert
      icon={isLoading ? <Spin indicator={<LoadingOutlined spin />} size="small" /> : undefined}
      message={alertProps.message}
      showIcon
      type={alertProps.type}
    />
  );
};

export default EODeliverInfoMessage;
